module.exports = __webpack_public_path__ + "img/geodir-sat-testimonial.c9c44a56.png";